import React from 'react'
import * as utils from "../../utils";

import RouterLink from "./router-link";

export default function RsvpToPerformActionButton(props) {
  const activity = props.action.toString();
  const uppercased =  activity.charAt(0).toUpperCase() + activity.slice(1);

  if (!utils.eventHasPassed()) {
    return (
      <RouterLink
        to={utils.eventTabUrlPath("rsvp")}
        className="button-secondary-inverse small-32"
        trackingSrc="rsvp-to-perform-action-button"
      >
        RSVP to {uppercased}
      </RouterLink>
    );
  } else {
    // Event has already passed, so no link to RSVP (since the guest can't anymore)
    // and say why.
    return (
        <p><span className="info-icon">!</span> You must have RSVP'd to {props.action}</p>
    )
  }
}



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/common/components/rsvp-to-perform-action-button.es6